import { render } from "./SessionScheduleNewRowButton.vue?vue&type=template&id=b70b45a0"
import script from "./SessionScheduleNewRowButton.vue?vue&type=script&lang=js"
export * from "./SessionScheduleNewRowButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__